module.exports = __webpack_public_path__ + "static/media/label-3.bf41c100.svg";